module.exports = __webpack_public_path__ + "img/alberto-mercado.f2277a1d.jpg";